// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Wrapper{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.Wrapper .alcor-button{border-radius:50%!important;height:28px;padding:0;width:28px}.ZoomOverlay{fill:rgba(0,0,0,0);cursor:-webkit-grab;cursor:grab}.ZoomOverlay:active{cursor:-webkit-grabbing;cursor:grabbing}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
